import {Component} from '@angular/core'
import {MatMiniFabButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {RouterLink} from '@angular/router'
import {HOME_PATH, PROFILE_PATH, SIGN_TYPE_PATH} from '../../general/shared'

@Component({
  selector: 'smt-header',
  imports: [
    MatIcon,
    RouterLink,
    MatMiniFabButton
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {

  protected readonly SIGN_TYPE_PATH = SIGN_TYPE_PATH
  protected readonly HOME_PATH = HOME_PATH
  protected readonly PROFILE_PATH = PROFILE_PATH
}
